$(function () {
	let $feedback = $('.helpArticle__feedback');

	$feedback.on('click', '[data-feedback]', function () {
		let type   = $(this).data('feedback');
		let $btn   = $(this);
		let $other = $('[data-feedback]').not($btn);
		let $plus  = $('.helpArticle__feedback-plus');
		let $minus = $('.helpArticle__feedback-minus');

		if ($btn.hasClass('btn-active')) return;
		if ($other.hasClass('btn-active') && $('input[name="feedback_rate"]:checked').length) return;

		$btn.addClass('btn-active');
		$other.removeClass('btn-active');

		if (type === 'plus') {
			$plus.addClass('is-visible');
			$minus.removeClass('is-visible');
		} else {
			$minus.addClass('is-visible');
			$plus.removeClass('is-visible');
		}
	});

	$(document).on('click', function (e) {
		if ($(e.target).closest('.helpArticle__nav-section-header').length) {
			$('.helpArticle__nav').toggleClass('mobile-open');
		} else {
			$('.helpArticle__nav').removeClass('mobile-open');
		}
	});

	$feedback.on('click', '.helpArticle__feedback-inputs .btn', function () {
		let $meta    = $feedback.find('[data-article-id]');
		let id_faq   = $meta.data('article-id');
		let thanks   = $meta.data('feedback-thanks');
		let $active  = $feedback.find('[data-feedback].btn-active');
		let rate     = parseInt($feedback.find('input[name="feedback_rate"]:checked').val(), 10);
		let $section = $(this).closest('.helpArticle__feedback-comment');
		let comment  = $section.find('textarea[name="feedback_comment"]').val().trim();
		let base     = $('body').attr('data-home') || '/';

		if (!id_faq) return;
		if (!rate) rate = $active.data('feedback') === 'plus' ? 1 : -1;

		$.post(base + 'help-center/feedback', { id_faq, rate, comment });

		$feedback.html(
			'<div class="helpArticle__feedback-texts">' +
			'<span class="helpArticle__feedback-question">' + thanks + '</span>' +
			'</div>'
		);
	});
});

(function () {
	let anchors  = Array.from(document.querySelectorAll('.helpArticle__nav-anchor'));
	let headings = Array.from(document.querySelectorAll('.typo h2[id]'));
	if (!anchors.length || !headings.length) return;

	window.addEventListener('scroll', render, { passive: true });

	function render() {
		let threshold = window.innerHeight / 2;
		let activeId  = null;

		for (let heading of headings) {
			let top = heading.getBoundingClientRect().top;
			if (top >= 0 && top <= threshold) { activeId = heading.id; break; }
		}

		if (!activeId) {
			for (let i = headings.length - 1; i >= 0; i--) {
				if (headings[i].getBoundingClientRect().top <= 0) { activeId = headings[i].id; break; }
			}
		}

		if (!activeId) return;

		for (let a of anchors) {
			a.classList.toggle('is-active', a.getAttribute('href') === '#' + activeId);
		}
	}
}());

// Права колонка: sticky з власним скролом. Поки вона ще не прилипла до top:20px, її верхній край нижче,
// і фіксований max-height calc(100vh - 20px) ховав низ колонки за вікно. Тримаємо низ рівно на краю вікна.
(function () {
	let nav = document.querySelector('.helpArticle__nav');
	if (!nav) return;
	let raf = 0;
	let desktop = window.matchMedia('(min-width: 801px)'); // до 800px колонка стає fixed-панеллю (adaptive.css)

	function apply() {
		raf = 0;
		if (!desktop.matches) { nav.style.removeProperty('--help-nav-max-h'); return; }
		let top = Math.max(20, nav.getBoundingClientRect().top);
		nav.style.setProperty('--help-nav-max-h', Math.max(160, window.innerHeight - top) + 'px');
	}
	function schedule() { if (!raf) raf = requestAnimationFrame(apply); }

	window.addEventListener('scroll', schedule, { passive: true });
	window.addEventListener('resize', schedule);
	apply();
}());
